import { Component, OnInit } from '@angular/core';
import { verificationDoc } from '@app/_models/verificationDoc';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common'
import { LogService } from '../../_shared/log.service';
import { headervalue } from '@headervalue/header';
import {VerifyDocumentEventServiceService} from '@app/_services/verify-document-event-service.service';
import { statusRemark } from '@app/_models/statusRemark';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';

@Component({
  selector: 'app-verification-list',
  templateUrl: './verification-list.component.html',
  styleUrls: ['./verification-list.component.css']
})
export class VerificationListComponent implements OnInit {
  dtTrigger: Subject<any> = new Subject<any>();
  request: verificationDoc[];

  title = 'docVerificationList';
  dtOptions: DataTables.Settings = {};

  statusRemark = new statusRemark();
  hideId = false;

  constructor(
    private verifyDocService: VerifyDocumentService, 
    private eventService: LogService, 
    public datepipe: DatePipe,
    private verifyDocumentEventServiceService: VerifyDocumentEventServiceService,
    private documentVerificationListService: DocumentVerificationListService
    ) { }

  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }

  editVerification(dataValue, routeVal) {
    console.log("dataval==", dataValue, "routeVal===", routeVal)
    this.eventService.emit<string>(routeVal)
    this.verifyDocumentEventServiceService.emit<any>(dataValue)
  }

  id
  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order:[[0, 'application_id']]
    };
    //this.eventService.emit<string>("1")
    // call function to get verification request from verifyDocument.service.ts
    // var userId = 78989;
    console.log(headervalue.headerWithJwt)
    var userId = localStorage.getItem('user_id');
    // var userId = 3;
    console.log(userId)
    this.verifyDocService.getVerificationDocs(userId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          console.log("response---id====", data.respData.id)
          this.request = data.respData;
          console.log("req===$===",this.request)
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }

  downloadPDF(element) {
    this.verifyDocService.getPDF(element)
      .subscribe(
        (data: Blob) => {
          var file = new Blob([data], { type: 'application/pdf' })
          var fileURL = URL.createObjectURL(file);

          var currentDate = new Date()

          // this.date=new Date();
          let latest_date = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

          // if you want to open PDF in new tab
          // window.open(fileURL); 
          var a = document.createElement('a');
          a.href = fileURL;
          a.target = element + '_' + latest_date;
          a.download = element + '_' + latest_date + '.pdf';
          document.body.appendChild(a);
          a.click();
        },
        (error) => {
          console.log('getPDF error: ', error);
        }
      );
  }

  downloadPDF1(element): void {
    var applicaionId = 123;


    let table = $('#mytable').DataTable({});

    alert(element);
    this.verifyDocService.downloadDF(applicaionId)
      .pipe(first())
      .subscribe(
        data => {
          //alert("success");
          console.log("response---", data)
          this.request = data.respData;
          console.log(this.request);

        },
        error => {
          console.log(error)
          alert("Error");
        },
      )
  }

  downloadCertificate(id, status) {

    console.log("in DOWNLOAD" + id + status);

    this.statusRemark.id = id;
    this.statusRemark.status = status;

    console.log("in STATUS RMK" + this.statusRemark.id + this.statusRemark.status + "ALL" + JSON.stringify(this.statusRemark));

    this.documentVerificationListService.getPDF(this.statusRemark)
    .subscribe(
      (data: Blob) => {
        var file = new Blob([data], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file);

        var currentDate = new Date()

        // this.date=new Date();
        let latest_date = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

        // if you want to open PDF in new tab
         window.open(fileURL); 
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = id + '_' + latest_date;
        a.download = id + '_' + latest_date + '.pdf';
        document.body.appendChild(a);
        a.click();
      },
      (error) => {
        console.log('getPDF error: ', error);
      }
    );

}

}
